import { Helmet } from 'react-helmet-async';

interface PageTitleProps {
  title: string;
  titleTemplate?: string;
  description?: string;
  keywords?: string | string[];
  author?: string;
  canonical?: string;
  robots?: string;
  lang?: string;
  og?: {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
    siteName?: string;
  };
  twitter?: {
    card?: 'summary' | 'summary_large_image' | 'app' | 'player';
    site?: string;
    creator?: string;
    title?: string;
    description?: string;
    image?: string;
  };
  children?: React.ReactNode;
}

export default function PageTitle({
  title,
  titleTemplate,
  description,
  keywords,
  author,
  canonical,
  robots,
  lang,
  og,
  twitter,
  children,
}: PageTitleProps) {
  const keywordsContent = Array.isArray(keywords)
    ? keywords.join(', ')
    : keywords;

  return (
    <Helmet
      titleTemplate={titleTemplate}
      htmlAttributes={lang ? { lang } : undefined}
    >
      <title>Pintu Berdikari | {title}</title>
      {description && <meta name="description" content={description} />}
      {keywordsContent && <meta name="keywords" content={keywordsContent} />}
      {author && <meta name="author" content={author} />}
      {robots && <meta name="robots" content={robots} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {og?.title && <meta property="og:title" content={og.title} />}
      {og?.description && (
        <meta property="og:description" content={og.description} />
      )}
      {og?.image && <meta property="og:image" content={og.image} />}
      {og?.url && <meta property="og:url" content={og.url} />}
      {og?.type && <meta property="og:type" content={og.type} />}
      {og?.siteName && <meta property="og:site_name" content={og.siteName} />}

      {twitter?.card && <meta name="twitter:card" content={twitter.card} />}
      {twitter?.site && <meta name="twitter:site" content={twitter.site} />}
      {twitter?.creator && (
        <meta name="twitter:creator" content={twitter.creator} />
      )}
      {twitter?.title && <meta name="twitter:title" content={twitter.title} />}
      {twitter?.description && (
        <meta name="twitter:description" content={twitter.description} />
      )}
      {twitter?.image && <meta name="twitter:image" content={twitter.image} />}

      {children}
    </Helmet>
  );
}
